import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { AlertTriangle, ReceiptText } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Dashboard-Widget: zeigt vergangene Trainings ohne jegliche Abrechnung
 * (keine Rechnung/Punkte/Abo/Karte). Versteckt sich, wenn alles sauber ist.
 * Klick führt zur Abrechnungs-Kontrolle.
 */
export default function UnbilledTrainingsWidget() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({ count: 0, total_amount: 0 });
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${API}/admin/billing-audit/unbilled?days=90`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setData({ count: res.data.count || 0, total_amount: res.data.total_amount || 0 });
      } catch (err) {
        // Nur Admins haben Zugriff — bei 403 einfach nichts anzeigen.
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading || data.count === 0) return null;

  return (
    <Card
      className="border-2 border-amber-300 bg-amber-50 cursor-pointer hover:bg-amber-100 transition-colors"
      onClick={() => navigate('/billing-audit')}
      data-testid="unbilled-trainings-widget"
    >
      <CardContent className="pt-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="bg-amber-100 text-amber-600 p-3 rounded-full">
              <ReceiptText size={24} />
            </div>
            <div>
              <h3 className="font-semibold text-gray-900">⚠️ Trainings ohne Abrechnung</h3>
              <div className="flex gap-4 mt-1 text-sm">
                <span className="text-amber-700 font-medium flex items-center gap-1">
                  <AlertTriangle size={14} />
                  <span data-testid="unbilled-trainings-count">{data.count}</span>&nbsp;Training{data.count === 1 ? '' : 's'}
                </span>
                <span className="text-amber-700 font-medium">
                  💰 CHF <span data-testid="unbilled-trainings-total">{data.total_amount.toFixed(2)}</span> nicht verrechnet
                </span>
              </div>
            </div>
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={(e) => { e.stopPropagation(); navigate('/billing-audit'); }}
            data-testid="unbilled-trainings-open-btn"
          >
            Kontrolle öffnen
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
